export default "__VITE_ASSET__BZK6G9Cc__"